import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AboutHero from "./components/AboutHero";
import MissionVision from "./components/MissionVision";
import ValuesSection from "./components/ValuesSection";
import TimelineSection from "./components/TimelineSection";
export default function AboutPage() {
  return (
    <div className="bg-[#080808] min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <AboutHero />
      <MissionVision />
      <ValuesSection />
      <TimelineSection />
      <Footer />
    </div>
  );
}
